module.exports = __webpack_public_path__ + "static/img/8.d9e503e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/sp/8.png
// module id = H+dm
// module chunks = 0